/**
 * Group-related actions
 */
(function( $ ) {
    'use strict';

    $(function() {
        var model_group = 'group';
        var drag = new AwesomeDrag();
        var a_ajax = new AwesomeAjax('aetfree');
        var aet_ajax = new AET_Ajax();
        var aet_animation = new AET_Animation();

        // Add New Group Button
        $('[data-action="add-group"]').on('click', function(){
            var args = {
                id: 'aet',
                item_id: '#',
                parent: '#wpcontent',
                html: '#group-add-wrap',
                model_name: model_group,
                direction: 'right',
                width: '100%',
                load_model: aet_ajax.load_model,
                callback_open: add_group_open_callback,
                callback_close: edit_group_close_callback
            };
            window.panel = new AwesomePanel(args);
            panel.init();
        });

        function bind_template_change(){
            $('[name="group_template"]', aet_panel).on('change', function(e){
                var layout = model.get('layout');
                var template = $(this).val();

                model.set('styles.' + layout, group_templates.get(layout)[template].styles);
                model.set('styles.' + layout + '.template', template);
                model.set('template', template);

                preview.destroy();
                preview.init();
            });
        }

        function bind_layout_change(){
            $('[name="group_layout"]', aet_panel).on('change', function(e){
                model.set('layout', $(this).val());

                preview.destroy();
                preview.init();
            });
        }

        // Add Group open callback
        function add_group_open_callback(){
            window.preview = new AwesomeGroup();
            preview.init().done(function () {
                bind_layout_change();
                bind_template_change();
                drag.init();
            });
            $('[data-action="shortcode-group"]', aet_panel).hide();
        }

        // Edit Group open callback
        function edit_group_open_callback(){
            window.preview = new AwesomeGroup();
            preview.init().done(function () {
                bind_layout_change();
                bind_template_change();
            });
            drag.init();
            show_shortcode_button();
        }

        // Edit Group close callback
        function edit_group_close_callback(){
            preview.destroy();
            drag.destroy();
            $('select', aet_panel).dropdown('destroy');
        }

        // Call edit Group panel on group card button click
        $('[data-action="edit-group"]').on('click', function(){
            var parent = $(this).parents('li[group-id]');
            var id = parseInt($(parent).attr('group-id'));

            var args = {
                id: 'aet',
                item_id: id,
                parent: '#wpcontent',
                html: '#group-edit-wrap',
                model_name: model_group,
                direction : 'right',
                width: '100%',
                load_model: aet_ajax.load_model,
                callback_open: edit_group_open_callback,
                callback_close: edit_group_close_callback
            };
            window.panel = new AwesomePanel(args);
            panel.init();
        });
        
        function set_group_testimonials_callback(images) {
            var dfd = $.Deferred();
            var ids = model.get('testimonials_ids');
            var $testimonials = $('#groups-list li[group-id="' + model.get('id') + '"] .group-members');
            $.each(ids, function (index, id) {
                $testimonials.append('<li><div class="foto">' + images[index] + '</div>');
            });
            dfd.resolve();
            return dfd;
        }

        // update group card after group save
        function update_group_card(){
            var dfd = $.Deferred();
            var ids = model.get('testimonials_ids');
            var $testimonials = $('#groups-list li[group-id="' + model.get('id') + '"] .group-members');
            var $count = $('#groups-list li[group-id="' + model.get('id') + '"] .employee-count');
            $testimonials.find('li[class!="empty"]').remove();
            $count.html('');
            if(ids.length > 0){
                $count.html(ids.length + ' people');
                aet_ajax.set_group_testimonials(ids, 'a-thumbnail', set_group_testimonials_callback).then(function(){
                    dfd.resolve();
                });
            }else{
                dfd.resolve();
            }
            $('#groups-list li[group-id="' + model.get('id') + '"] span.name').html(model.get('name'));
            return dfd;
        }

        // show shortcode button after create/update
        function show_shortcode_button(){
            var id = model.get('id');
            if(id !== 0){
                var result = '[a-excited-testimonials id="' + id + '"]';
                $('[data-action="shortcode-group"]', aet_panel).find('input').val(result);
                $('[data-action="shortcode-group"]', aet_panel).show();
            }
        }

        // Save Group
        $('#group-edit-wrap .save-panel, #group-add-wrap .save-panel').on('click', function(){
            if(window.model.locked){
                return false; // prevent double click on save button
            }

            var form = $('[data-type="form"]', aet_panel);
            var model = $(form).attr('data-model');
            var $alert = form.find('.alert');
            $alert.attr('class', 'alert').hide();
            window.model.locked = true;

            window.panel.hide_content();
            window.panel.animation_start(); // show animation

            var group_model = window.model.clone();
            group_model.unset('grid_html');
            group_model.unset('grid_float_html');
            group_model.unset('single');
            group_model.unset('single_showcase');
            group_model.unset('widget');
            group_model.unset('fill_rules');

            a_ajax.ajax({
                action: 'aetfree_update_or_new_' + model,
                data: {
                    data: group_model.toJSON(),
                },
                success_handler: function (data) {
                    window.model.set('id', data);
                    show_shortcode_button();
                    update_group_card().then(function () {
                        window.panel.show_content();
                        window.panel.animation_end();
                        window.model.locked = false;
                    });
                },
                success_error_handler: function (errors) {
                    var html = '';
                    $.each(errors, function (index, value) {
                        html += '<p>';
                        html += value.message;
                        html += '</p>';
                    });
                    $alert.addClass('alert-warning').show().html(html);
                    window.panel.show_content();
                    window.panel.animation_end();
                    window.model.locked = false;
                },
                error_handler: function (data) {
                    $alert.addClass('alert-warning').show().html(data);
                    window.model.locked = false;
                }
            });
        });

        // Delete Group on group card button click
        $('[data-action="delete-group"]').on('click', function(){
            var $parent = $(this).parents('li[group-id]');
            var $spinner = $(this).find('.a-spinner');
            var $icon = $(this).find('svg');
            var id = parseInt($parent.attr('group-id'));
            var model_name = model_group;

            if(confirm('You really want to delete group?')) {
                $icon.hide(); // hide icon
                $spinner.show(); // show animation
                a_ajax.delete_model(id, model_name).then(function () {
                    aet_animation.delete_model($parent, model_name);
                });
            }
        });

        // Get Group Shortcode
        $('[data-action="shortcode-group"]').on({'mouseenter': function(){
            var $tooltip = $(this).find('.a-tooltip-wrapper'),
                $btn = $(this).find('button');
            setTimeout(function(){
                $tooltip.find('input').select();
            },300);
        },'mouseleave': function(){
            $(this).find('.a-tooltip-wrapper');
        }});

        $('[data-action="copy-to-clipboard"]').on('click', function () {
            var $btn = $(this),
                text = $($btn.attr('data-copytarget')).val(),
                origin_text = $btn.html(),
                origin_width = $btn.outerWidth();
            clipboard.copy(text);
            $btn.html('<span>Copied!</span>').css('width', origin_width);
            setTimeout(function () {
                $btn.html(origin_text);
            },2000);
        });

        $('[data-action="modal"]').lightbox({
            minWidth: 50,
            minHeight: 100
        });

        // Custom CSS Spoiler
        $('[data-toggle="collapse"]').on('click', function () {
            var target_id = $(this).attr('data-target');
            $(target_id, aet_panel).toggleClass('in');
        });

    });
})( jQuery );